export default {
    m000001: 'Please enter the 6-digit trading password you are currently using to verify your identity.',
    m000002: 'Please enter your trading password',
    m000003: 'Forgot trading password',
    m000004: 'Please set a trading password',
    m000005: 'Trading password',
    m000006: 'Confirm trading password',
    m000007: 'The password length is 6 digits',
    m000008: 'Password must be numeric',
    m000009: 'The new passwords you enter twice must be the same',
    m000010: 'If you encounter any problems, please',
    m000011: 'Contact Customer Service', 
    m000012: 'Tip: You can manage your transaction verification method by visiting the Me - Security center page',
    m000013: 'Trading password set successfully',
    m000014: 'Please enter your trading password',
    m000015: 'Please enter your 6-digit trading password',
    m000016: 'Please enter your trading password again',
    m000017: 'The passwords entered twice are not the same',
    m000018: 'Please enter the identity information you submitted when you opened your account to verify your identity.',
    m000019: 'ID Number',
    m000020: 'Email',
    m000021: 'Please enter your ID number',
    m000022: 'Please enter your email',
    m000023: 'Reset successfully!',
    m000024: 'Online customer service',
    m000025: 'Tip: Please install WeChat in advance and log in',
    m000026: 'Hotline',
    m000027: 'Email',
    m000028: 'Close',
    m000029: 'Encounter problems',
    m000030: 'I forget the password',
    m000031: 'Contact Customer Service',
    m000032: 'Modified successfully!',
    m000033: 'Change Trading Password',
    m000034: 'Reset Trading Password',
    m000035: 'Confirm',
    m000036: 'Set',
    m000037: 'Later',
    m000038: 'Identity Address',
    m000039: 'Residential Address',
}